import { IonDate } from './../i-components/IonDate.tsx';

const CheckNotNull = Symbol('CheckNotNull');

class MembershipContract {
    public contractID: string = '';
    public paymentID: string = '';
    public memberID: string = '';
    public min_term: Date | null = null;
    public max_term: Date | null = null;
    public datetime_created: Date | null = null;

    constructor(
        contractID: string,
        paymentID: string,
        memberID: string,
        min_term: string,
        max_term: string,
        datetime_created: string,
    ) {
        this.contractID = this[CheckNotNull](contractID) ? contractID : '';
        this.paymentID = this[CheckNotNull](paymentID) ? paymentID : '';
        this.memberID = this[CheckNotNull](memberID) ? memberID : '';
        this.min_term = this[CheckNotNull](min_term) ? IonDate(min_term + ' 00:00:00') : null;
        this.max_term = this[CheckNotNull](max_term) ? IonDate(max_term + ' 00:00:00') : null;
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
    }

    //privates
    private [CheckNotNull] = (value: string) => {
        if (value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default MembershipContract;